module.exports = __webpack_public_path__ + "static/media/corporate-short-programme.5cf33ca3.png";